var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","inputmode":"numeric"},domProps:{"value":_vm.internalValue},on:{"change":_vm.onChange,"keydown":_vm.onKeyDown,"click":_vm.onClick,"focus":_vm.onFocus}})}
var staticRenderFns = []

export { render, staticRenderFns }